module.exports = __webpack_public_path__ + "assets/img/catB.65f5741a.svg";